import { useGameProviderBySlug } from '@/api/game-providers';

export function useOriginalsAggregator() {
  const { gameProvider } = useGameProviderBySlug({
    slug: 'ice-games',
  });

  return {
    isActive: gameProvider?.isActive,
  };
}
